import { ITextBlockProps } from '../../../shared/components/v2/TextBlock/TextBlock'
import {
  ModuleBackgroundColors,
  ModuleMargin,
  ModulePadding,
} from '../../../shared/components/v2/ModuleSection/ModuleSection'
import { TEXT_FONT_COLOR, TEXT_FONT_STYLE, TEXT_TAG } from '../../../shared/components/v2/Text/TextV2'
import { ComponentType } from '../../../shared/components/v2/types/componentType'
import { actionButtonStyle } from '../../../shared/components/v2/ActionButton/ActionButton'

export const careersAtNorthOneProps: ITextBlockProps = {
  moduleBackgroundColor: { desktop: ModuleBackgroundColors.white },
  modulePadding: { top: ModulePadding.XL, bottom: ModulePadding.SM },
  mobileModulePadding: { top: ModulePadding.XL, bottom: ModulePadding.XS },
  moduleMargin: { top: ModuleMargin.SM },
  title: {
    tag: TEXT_TAG.h1,
    text: 'Careers at NorthOne',
    textFontStyle: TEXT_FONT_STYLE.h1,
    textFontColor: TEXT_FONT_COLOR.blackPrimary,
    sx: {
      marginBottom: '12px',
    },
  },
  body: [
    {
      type: ComponentType.Text,
      props: {
        tag: TEXT_TAG.p,
        text: 'Our mission is big and audacious.\nJoin us as we work to change the future of banking.',
        textFontStyle: TEXT_FONT_STYLE.bodyXXlargeLight,
        textFontColor: TEXT_FONT_COLOR.copperPrimary,
        sx: {
          marginBottom: '32px',
        },
      },
    },
    {
      type: ComponentType.Text,
      props: {
        tag: TEXT_TAG.p,
        text: `We're focused on solving real problems instead of just selling financial products and making the world of finance simpler for business builders across the country. Don't just find a job, find a career path doing impactful work.`,
        textFontStyle: TEXT_FONT_STYLE.bodyXlargeLight,
        textFontColor: TEXT_FONT_COLOR.blackPrimary,
        sx: {
          marginBottom: '32px',
        },
      },
    },
    {
      type: ComponentType.Text,
      props: {
        tag: TEXT_TAG.p,
        text: `Our team works at a fast pace, and is growing quickly.\n See our available job openings and let's figure out together if this is where you could shine.`,
        textFontStyle: TEXT_FONT_STYLE.bodyXlargeLight,
        textFontColor: TEXT_FONT_COLOR.blackPrimary,
        sx: {
          marginBottom: '12px',
        },
      },
    },
    {
      type: ComponentType.ActionButton,
      props: {
        body: {
          tag: TEXT_TAG.p,
          text: 'Job openings',
          textFontStyle: TEXT_FONT_STYLE.ctaButton,
          textFontColor: TEXT_FONT_COLOR.white,
        },
        link: 'https://boards.greenhouse.io/northone',
        buttonStyle: actionButtonStyle.copperPrimary,
        sx: {
          width: ['100%', '100%', 'initial'],
        },
      },
    },
  ],
}

const CustomStorycardStyles = {
  titleSx: {
    marginY: '10px',
  },
  imageSx: {
    height: '120px',
    paddingLeft: '20px',
  },
  sx: {
    height: '411px',
  },
}
export const careersBenefitsProps: ITextBlockProps = {
  moduleBackgroundColor: { desktop: ModuleBackgroundColors.white },
  modulePadding: { top: ModulePadding.SM, bottom: ModulePadding.L },
  moduleMargin: { top: ModuleMargin.SM },
  title: {
    tag: TEXT_TAG.h2,
    text: 'Employee bene&#xFB01;ts',
    textFontStyle: TEXT_FONT_STYLE.h2,
    textFontColor: TEXT_FONT_COLOR.blackPrimary,
    sx: {
      marginBottom: '12px',
    },
  },
  body: [
    {
      type: ComponentType.Text,
      props: {
        tag: TEXT_TAG.p,
        text: `We want to give our team everything they need to make magic happen. We're always improving our employee benefits, but here's what we offer right now. If you'd like more information on any of them, let's talk!`,
        textFontStyle: TEXT_FONT_STYLE.bodyXlargeLight,
        textFontColor: TEXT_FONT_COLOR.blackPrimary,
        sx: {
          marginBottom: '41px',
        },
      },
    },
    {
      type: ComponentType.StoryCardList,
      props: {
        sx: {
          display: 'grid',
          gridTemplateColumns: ['1fr', '1fr', 'repeat(3,1fr)'],
          columnGap: '32px',
          rowGap: ['10px', '10px', '32px'],
          marginBottom: '30px',
        },
        storyCards: [
          {
            backgroundColor: { desktop: ModuleBackgroundColors.copperTint3 },
            title: {
              tag: TEXT_TAG.h3,
              text: 'Community',
              textFontStyle: TEXT_FONT_STYLE.h4,
              textFontColor: TEXT_FONT_COLOR.blackPrimary,
              sx: CustomStorycardStyles.titleSx,
            },
            body: {
              tag: TEXT_TAG.p,
              text:
                'Bond with your teammates over shared interests at regular get-togethers. Find like-minded people who are passionate about everything from sport and music to gaming and cooking.',
              textFontStyle: TEXT_FONT_STYLE.bodyLargeLight,
              textFontColor: TEXT_FONT_COLOR.blackPrimary,
            },
            imageSrc: '/static/v2/careers-page/community.png',
            imageAlt: '',
            imageSx: CustomStorycardStyles.imageSx,
            sx: CustomStorycardStyles.sx,
          },
          {
            backgroundColor: { desktop: ModuleBackgroundColors.copperTint4 },
            title: {
              tag: TEXT_TAG.h3,
              text: 'Learning',
              textFontStyle: TEXT_FONT_STYLE.h4,
              textFontColor: TEXT_FONT_COLOR.blackPrimary,
              sx: CustomStorycardStyles.titleSx,
            },
            body: {
              tag: TEXT_TAG.p,
              text:
                "We support lifelong learners by covering the cost of classes, workshops and conferences. You'll also get access to our ever-growing library of industry-related books.",
              textFontStyle: TEXT_FONT_STYLE.bodyLargeLight,
              textFontColor: TEXT_FONT_COLOR.blackPrimary,
            },
            imageSrc: '/static/v2/careers-page/learning.png',
            imageAlt: '',
            imageSx: CustomStorycardStyles.imageSx,
            sx: CustomStorycardStyles.sx,
          },
          {
            backgroundColor: { desktop: ModuleBackgroundColors.copperTint3 },
            title: {
              tag: TEXT_TAG.h3,
              text: 'Health and dental',
              textFontStyle: TEXT_FONT_STYLE.h4,
              textFontColor: TEXT_FONT_COLOR.blackPrimary,
              sx: CustomStorycardStyles.titleSx,
            },
            body: {
              tag: TEXT_TAG.p,
              text:
                'We care about the people we work with and put their health first. NorthOne is proud to offer inclusive health and dental coverage.',
              textFontStyle: TEXT_FONT_STYLE.bodyLargeLight,
              textFontColor: TEXT_FONT_COLOR.blackPrimary,
            },
            imageSrc: '/static/v2/careers-page/health-dental.png',
            imageAlt: '',
            imageSx: CustomStorycardStyles.imageSx,
            sx: CustomStorycardStyles.sx,
          },
          {
            backgroundColor: { desktop: ModuleBackgroundColors.copperTint4 },
            title: {
              tag: TEXT_TAG.h3,
              text: 'Unlimited Vacation',
              textFontStyle: TEXT_FONT_STYLE.h4,
              textFontColor: TEXT_FONT_COLOR.blackPrimary,
              sx: CustomStorycardStyles.titleSx,
            },
            body: {
              tag: TEXT_TAG.p,
              text: `We hire talented people and know that sometimes they need time off to be at their best. Recharge and make sure you're working sustainably.`,
              textFontStyle: TEXT_FONT_STYLE.bodyLargeLight,
              textFontColor: TEXT_FONT_COLOR.blackPrimary,
            },
            imageSrc: '/static/v2/careers-page/vacation-gold.png',
            imageAlt: '',
            imageSx: CustomStorycardStyles.imageSx,
            sx: CustomStorycardStyles.sx,
          },
          {
            backgroundColor: { desktop: ModuleBackgroundColors.copperTint3 },
            title: {
              tag: TEXT_TAG.h3,
              text: 'Diversity and Inclusivity',
              textFontStyle: TEXT_FONT_STYLE.h4,
              textFontColor: TEXT_FONT_COLOR.blackPrimary,
              sx: CustomStorycardStyles.titleSx,
            },
            body: {
              tag: TEXT_TAG.p,
              text: `We need people who solve big problems using their unique perspective. Excellence doesn't come in one flavor - and neither should we.`,
              textFontStyle: TEXT_FONT_STYLE.bodyLargeLight,
              textFontColor: TEXT_FONT_COLOR.blackPrimary,
            },
            imageSrc: '/static/v2/careers-page/diversity-blue.png',
            imageAlt: '',
            imageSx: CustomStorycardStyles.imageSx,
            sx: CustomStorycardStyles.sx,
          },
          {
            backgroundColor: { desktop: ModuleBackgroundColors.copperTint4 },
            title: {
              tag: TEXT_TAG.h3,
              text: 'Flex time',
              textFontStyle: TEXT_FONT_STYLE.h4,
              textFontColor: TEXT_FONT_COLOR.blackPrimary,
              sx: CustomStorycardStyles.titleSx,
            },
            body: {
              tag: TEXT_TAG.p,
              text: `We don't clock in and out at set times. You know when you do your best work. We celebrate accomplishments, not how many hours are spent at the office.`,
              textFontStyle: TEXT_FONT_STYLE.bodyLargeLight,
              textFontColor: TEXT_FONT_COLOR.blackPrimary,
            },
            imageSrc: '/static/v2/careers-page/hours.png',
            imageAlt: '',
            imageSx: CustomStorycardStyles.imageSx,
            sx: CustomStorycardStyles.sx,
          },
        ],
      },
    },
  ],
}
const path = '/static/v2/locations-block'
export const careersLocationsBlock = {
  moduleBackgroundColor: {
    desktop: ModuleBackgroundColors.copperPrimary,
    mobile: ModuleBackgroundColors.copperPrimary,
  },
  modulePadding: {
    top: ModulePadding.NONE,
    bottom: ModulePadding.NONE,
  },

  dataTestId: 'our-team-locations',
  locations: [
    {
      title: {
        tag: TEXT_TAG.h4,
        text: 'New York O&#xFB03;ce',
        textFontStyle: TEXT_FONT_STYLE.h4,
        textFontColor: TEXT_FONT_COLOR.white,
      },
      address: {
        tag: TEXT_TAG.p,
        text: '18 West 18th Street,\nNew York, NY 10011',
        textFontStyle: TEXT_FONT_STYLE.bodyLargeLight,
        textFontColor: TEXT_FONT_COLOR.white,
      },
      iconSrc: `${path}/team-New-York-City-icon.svg`,
      iconAltText: 'blue statue of liberty graphic',
      mapSrc: `${path}/New-York-Office-map.png`,
      mapAltText: 'blue statue of liberty graphic',
      mapLink:
        'https://www.google.com/maps/place/18+W+18th+St,+New+York,+NY+10011/@40.7390047,-73.9955218,17z/data=!3m1!4b1!4m5!3m4!1s0x89c259a2dd0576f9:0x8caea46dadd751c6!8m2!3d40.7390007!4d-73.9933331?shorturl=1',
    },
    {
      title: {
        tag: TEXT_TAG.h4,
        text: 'San Francisco O&#xFB03;ce',
        textFontStyle: TEXT_FONT_STYLE.h4,
        textFontColor: TEXT_FONT_COLOR.white,
      },
      address: {
        tag: TEXT_TAG.p,
        text: '650 California St., Floor 7\nSan Francisco, CA 94108',
        textFontStyle: TEXT_FONT_STYLE.bodyLargeLight,
        textFontColor: TEXT_FONT_COLOR.white,
      },
      iconSrc: `${path}/team-San-Francisco-icon.svg`,
      iconAltText: 'Golden Gate Bridge icon',
      mapSrc: `${path}/San-Francisco-Office-map.png`,
      mapAltText: 'Golden Gate Bridge icon',
      mapLink:
        'https://www.google.com/maps/place/650+California+St,+San+Francisco,+CA+94108,+USA/@37.7927929,-122.4072887,17z/data=!3m1!4b1!4m5!3m4!1s0x808581a2b338135f:0xb2d0c4277502c135!8m2!3d37.7927929!4d-122.4051',
    },
    {
      title: {
        tag: TEXT_TAG.h4,
        text: 'Portland O&#xFB03;ce',
        textFontStyle: TEXT_FONT_STYLE.h4,
        textFontColor: TEXT_FONT_COLOR.white,
      },
      address: {
        tag: TEXT_TAG.p,
        text: '920 SW 6th Ave, Suite 1200\nPortland, OR 97204',
        textFontStyle: TEXT_FONT_STYLE.bodyLargeLight,
        textFontColor: TEXT_FONT_COLOR.white,
      },
      iconSrc: `${path}/team-Portland-icon.svg`,
      iconAltText: ' Portland tree icon',
      mapSrc: `${path}/Portland-Office-map.png`,
      mapAltText: 'Portland tree icon',
      mapLink:
        'https://www.google.com/maps/place/Public+Service+Building,+920+SW+6th+Ave+Ste+1200,+Portland,+OR+97204,+USA/@45.5173353,-122.6813817,17z/data=!3m1!4b1!4m5!3m4!1s0x54950a0545d1f5d3:0x4f91a61c3e637157!8m2!3d45.5173353!4d-122.679193',
    },
    {
      title: {
        tag: TEXT_TAG.h4,
        text: 'Toronto O&#xFB03;ce',
        textFontStyle: TEXT_FONT_STYLE.h4,
        textFontColor: TEXT_FONT_COLOR.white,
      },
      address: {
        tag: TEXT_TAG.p,
        text: '1050 King St W\nToronto, ON M6K 0C7',
        textFontStyle: TEXT_FONT_STYLE.bodyLargeLight,
        textFontColor: TEXT_FONT_COLOR.white,
      },
      iconSrc: `${path}/team-Toronto-icon.svg`,
      iconAltText: 'The CN tower in Toronto Canada',
      mapSrc: `${path}/Toronto-Office-map.png`,
      mapAltText: 'The CN tower in Toronto Canada',
      mapLink: 'https://goo.gl/maps/fcUx2MbqMXP14o168',
    },
  ],
}
